<div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row p-3">
                <div class="col-12">
                    <p class="text-danger">{{ data.message }}</p>
                            
                    <div class="text-center mb-3" *ngIf="data.for == 'payment_eligibility'">
                        <button mat-dialog-close color="primary" mat-raised-button routerLink="/home/pay-tuition">Make Payment</button>
                    </div>
                </div>
                   
            </div>
        </div>
    </div>
</div>